export const ACCOUNT_REDUX_FORM_ID = 'AccountForm';



// WEBPACK FOOTER //
// ./src/config/account.js